import React from "react";
import { Link } from "react-router-dom";

// Colores de las pantallas con tema. Son variables CSS: las pone Layout según el tema que eligió el
// administrador (utils/temas.js), con el Institucional como respaldo.
export const TEMA = {
  azul: "var(--tema-primario, #1f4e96)",
  azulOscuro: "var(--tema-titulo, #0b3c60)",
  franja: "var(--tema-franja, #0b3c60)",
  dorado: "var(--tema-acento, #fec900)",
  azulSuave: "var(--tema-suave, #eef3fa)",
  linea: "var(--tema-linea, #d5deec)",
  franjaTexto: "var(--tema-franjaTexto, #ffffff)",
  franjaSub: "var(--tema-franjaSub, #c7d0e0)",
  enlace: "var(--tema-enlace, #ffe28a)",
};

// Color del monto según en qué va: de un vistazo se ve si ya se pagó o si falta.
const TONOS_MONTO = {
  pagado: { fondo: "#dcf0e6", texto: "#1e5e3f" },
  pendiente: { fondo: "#fdf0d5", texto: "#8a5a00" },
  proceso: { fondo: "#d7e8f7", texto: "#1d5fa8" },
  vencido: { fondo: "#f7ded9", texto: "#a3402f" },
};

// Franja de arriba: título, solicitud y estado a la izquierda; monto destacado (o una acción) a la derecha.
export function EncabezadoDetalle({ titulo, enlace, enlaceTexto, subtitulo, insignia, etiquetaMonto, monto, notaMonto, tono = "pendiente", accion }) {
  const colores = TONOS_MONTO[tono] || TONOS_MONTO.pendiente;
  return (
    <div style={estilos.franja}>
      <div style={{ minWidth: 0, flex: "1 1 280px" }}>
        <h2 className="sin-subrayado" style={estilos.titulo}>{titulo}</h2>
        <div style={estilos.fila}>
          {enlace && (
            <Link to={enlace} style={estilos.enlace}>
              {enlaceTexto}
            </Link>
          )}
          {insignia}
        </div>
        {subtitulo && <div style={estilos.subtitulo}>{subtitulo}</div>}
      </div>
      {monto && (
        <div style={{ ...estilos.monto, background: colores.fondo, color: colores.texto }}>
          <div style={estilos.montoEtiqueta}>{etiquetaMonto}</div>
          <div style={estilos.montoValor}>{monto}</div>
          {notaMonto && <div style={estilos.montoNota}>{notaMonto}</div>}
        </div>
      )}
      {accion}
    </div>
  );
}

// Tarjeta con filete azul arriba.
export const tarjetaTema = { borderTop: `3px solid ${TEMA.azul}` };

// Título de sección con barra dorada, para ubicarse de un vistazo.
export const tituloSeccionTema = {
  fontSize: "0.82rem",
  fontWeight: 800,
  color: TEMA.azulOscuro,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
  borderLeft: `4px solid ${TEMA.dorado}`,
  paddingLeft: "0.55rem",
};

// Encabezado de tabla: azul con letras blancas, igual que las tablas del sistema.
export const thTema = { background: TEMA.azul, color: "#fff" };

const estilos = {
  franja: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
    marginTop: "0.5rem",
    padding: "1.05rem 1.3rem",
    background: TEMA.franja,
    borderBottom: `4px solid ${TEMA.dorado}`,
    borderRadius: 14,
    boxShadow: "0 4px 14px rgba(11,60,96,0.22)",
  },
  titulo: { margin: 0, color: TEMA.franjaTexto, fontSize: "1.25rem", textAlign: "left" },
  fila: { display: "flex", alignItems: "center", gap: "0.6rem", flexWrap: "wrap", marginTop: "0.35rem" },
  enlace: { color: TEMA.enlace, fontWeight: 700, fontSize: "0.92rem", textDecoration: "none" },
  subtitulo: { color: TEMA.franjaSub, fontSize: "0.84rem", marginTop: "0.25rem" },
  monto: { borderRadius: 12, padding: "0.6rem 1.1rem", textAlign: "right", flexShrink: 0 },
  montoEtiqueta: { fontSize: "0.68rem", fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase" },
  montoValor: { fontSize: "1.5rem", fontWeight: 800, fontVariantNumeric: "tabular-nums", lineHeight: 1.2 },
  montoNota: { fontSize: "0.78rem", fontWeight: 600 },
};
